import { object } from '@gogame/schemas';

import { SCOPE_PAGES } from 'scenes/Gallery/ConversionPages/constants';

import { columnsSchema } from './columnsSchema';
import { tableSettingsSchema } from './tableSettingsSchema';

export const scopeSchema = object(
  {
    columns: columnsSchema,
    tableSettings: tableSettingsSchema,
  },
  SCOPE_PAGES
);
